import { Box } from '@factorialco/deprecated-design-system'
import {
  WorkTimeCategoriesContractTaxonomyFragment,
  WorkTimeCategoriesReimbursableSupplementTaxonomyFragment,
} from 'generated/resources/graphql'
import { Dictionary } from 'lodash'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { ReimbursableTaxonomiesMappingForm } from 'modules/attendance/lib/forms/utils/CustomTimeRangesFormData'

interface Props {
  legalEntityId: string
  legalEntityName: string
  mappingsGrouped: Dictionary<WorkTimeCategoriesReimbursableSupplementTaxonomyFragment[]>
  formMappingsGrouped: Dictionary<ReimbursableTaxonomiesMappingForm[]>
  taxonomiesByLegalEntity: Dictionary<WorkTimeCategoriesContractTaxonomyFragment[]>
  timeSettingsCategoryId?: string
  onChange: (props: { taxonomyId: string; legalEntityId: string; mappingId?: string }) => void
}

const TaxonomySelect = ({
  mappingsGrouped,
  legalEntityId,
  legalEntityName,
  formMappingsGrouped,
  taxonomiesByLegalEntity,
  timeSettingsCategoryId,
  onChange,
}: Props) => {
  const mappingKey = `${legalEntityId}_${timeSettingsCategoryId}`
  const mapping = mappingsGrouped[mappingKey]?.[0]
  const formMapping = formMappingsGrouped[mappingKey]?.[0]
  const legalEntityTaxonmomies = taxonomiesByLegalEntity[legalEntityId] ?? []
  const options = legalEntityTaxonmomies.map((taxonomy) => ({
    label: taxonomy.name,
    value: taxonomy.id,
  }))

  const persistedValue = mapping?.supplementTaxonomyId
  const selectedValue = formMapping?.supplementTaxonomyId

  const renderedValue = selectedValue || persistedValue

  const onFieldChange = (taxonomyId: string) => {
    onChange({ taxonomyId, mappingId: mapping?.id, legalEntityId })
  }

  return (
    <Box key={legalEntityId}>
      <SelectField
        label={legalEntityName}
        options={options}
        none={
          !persistedValue
            ? i18n.t('time_tracking.settings.time_blocks.categories.modals.select')
            : undefined
        }
        onChange={onFieldChange}
        value={renderedValue}
      />
    </Box>
  )
}

export default TaxonomySelect
